<style>
#watermeters .caption--long {
  display: block;
  max-width: 180px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div class="group">
      <button
        class="ribbon-button"
        @click="openRegister('prw')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption caption--long">REJESTR PUNKTÓW ROZBIORU WODY</span>
      </button>
    </div>
    <div class="group">
      <button
        class="ribbon-button btn--large"
        @click="openRegister('watermeter')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR WODOMIERZY</span>
      </button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';

export default {
  components: {
    vueCustomScrollbar
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    openRegister(registerType) {
      this.$root.$emit("loadWatermeters");
      if(registerType == 'prw') {
        this.show('prwRegisterModal');
      } else {
        this.show('watermetersRegisterModal');
      }
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/watermeters/Watermeters.vue